<div class="data-table-wrapper">
  <table mat-table [dataSource]="dataSource" matSort class="data-table">
    @for (id of columnIds; track id; let i = $index) {
      <ng-container [matColumnDef]="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [arrowPosition]="numeric[i] ? 'before' : 'after'"
            [class.data-table-cell--numeric]="numeric[i]">
          {{ labels[i] }}
        </th>
        <td mat-cell *matCellDef="let row" [class.data-table-cell--numeric]="numeric[i]" [attr.title]="cell(row, i)">
          @if (chipColor(row, i); as color) {
            <mat-chip-set>
              <mat-chip [color]="color" disableRipple>{{ cell(row, i) }}</mat-chip>
            </mat-chip-set>
          } @else {
            {{ cell(row, i) }}
          }
        </td>
      </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="columnIds; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columnIds"></tr>
  </table>
</div>

<mat-paginator
  [class.data-table-paginator--hidden]="!paged"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  showFirstLastButtons
/>
@if (!paged) {
  <p class="data-table-count">{{ (rows.length === 1 ? 'colimind.table.row' : 'colimind.table.rows') | translate: { count: rows.length } }}</p>
}
